// extracted by mini-css-extract-plugin
module.exports = {"TooltipPopup":"TooltipPopup_TooltipPopup__Ou5zu","Title":"TooltipPopup_Title__sDdAp","Payload":"TooltipPopup_Payload__lEpPk"};